export const USER_REQUEST = "USER_REQUEST";
export const USER_SUCCESS = "USER_SUCCESS";
export const USER_FAILURE = "USER_FAILURE";

export const FOLLOWER_REQUEST = "FOLLOWER_REQUEST";
export const FOLLOWER_SUCCESS = "FOLLOWER_SUCCESS";
export const FOLLOWER_FAILURE = "FOLLOWER_FAILURE";

export const GET_FOLLOWER_SUCCESS="GET_FOLLOWER_SUCCESS";